import { useAtomValue } from "jotai";
import { paymentReceiptAtom } from "../../../state";
import styles from "./style.module.scss";
import { Button } from "../../../custom";
import { useRef } from "react";
import { ReactComponent as Logo } from "../../../assets/James-Hope-University-Logo.svg";
import { ReactComponent as BackArrow } from "../../../assets/arrow-back.svg";
import { formatFullDate, formattedTime } from "../../../utils/formatDate";
import { formatCurrency } from "../../../utils/currency";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../routes";
import { userAtom } from "../../../utils/store";
import { useGetApplicantDetailsQuery } from "../../../hooks/api/useGetApplicantDetailsQuery";

const PaymentReceipt = () => {
  const storedUser = useAtomValue(userAtom);
  const { applicantDetails } = useGetApplicantDetailsQuery({
    applicantId: storedUser?.applicantId,
  });
  const user = applicantDetails ?? storedUser;
  const data = useAtomValue(paymentReceiptAtom);
  const receiptRef = useRef(null);
  const navigate = useNavigate();

  const printReceipt = useReactToPrint({
    contentRef: receiptRef,
    documentTitle: `Payment_Receipt_${data?.paymentReference}`,
  });

  if (!data) {
    return <p>No receipt data available.</p>;
  }
  return (
    <div>
      <section className={styles.heading}>
        <div className={styles.back}>
          <button
            className={styles.backButton}
            onClick={() => navigate(routes.dashboard.payments)}
          >
            <BackArrow width={24} height={24} />
          </button>
          <h3>Payment Receipt</h3>
        </div>
        <Button onClick={printReceipt} text="Print Receipt" />
      </section>
      <br />
      <section ref={receiptRef} className={styles.receiptContainer}>
        <div className={styles.watermark}>
          <Logo />
        </div>
        <div className={styles.receiptContent}>
          <div className={styles.letterHead}>
            <div className={styles.spaceBetween}>
              <Logo className={styles.logo} />
              <div>
                <h1>Receipt</h1>
                <small>
                  <b>Receipt no: {data?.paymentReference}</b>
                </small>
              </div>
            </div>
          </div>
          <h2>PTI Payment Receipt</h2>
          <br />
          <div className={styles.grid}>
            <div className={styles.receiptDetails}>
              <label>Payment Date</label>
              <h6>
                {formatFullDate(data?.paymentDate)},{" "}
                {formattedTime(data?.paymentDate)}
              </h6>
            </div>
            <div className={styles.receiptDetails}>
              <label>Applicant Name</label>
              <h6>{data?.fullName}</h6>
            </div>
            <div className={styles.receiptDetails}>
              <label>Reference Number</label>
              <h6>{data?.paymentReference}</h6>
            </div>
            <div className={styles.receiptDetails}>
              <label>Purpose of Payment</label>
              <h6>{data?.category}</h6>
            </div>
            <div className={styles.receiptDetails}>
              <label>Amount</label>
              <h6>{formatCurrency(data?.amount)}</h6>
            </div>
            <div className={styles.receiptDetails}>
              <label>Program</label>
              <h6>{user?.programName}</h6>
            </div>
            <div className={styles.receiptDetails}>
              <label>Degree Type</label>
              <h6>{user?.programType}</h6>
            </div>
            <div className={styles.receiptDetails}>
              <label>Mode of Study</label>
              <h6>{user?.modeOfStudyName}</h6>
            </div>
            <div className={styles.receiptDetails}>
              <label>Status</label>
              <h6>{data?.paymentStatus}</h6>
            </div>
            <div className={styles.note}>
              <p>
                <b>Receipt number: {data?.paymentReference}</b>
              </p>
              <p>
                <b>PETROLEUM TRAINING INSTITUTE, EFFURUN , DELTA STATE</b>

              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PaymentReceipt;
